import { render, staticRenderFns } from "./OrdersKanban.vue?vue&type=template&id=53bd3437&scoped=true&"
import script from "./OrdersKanban.vue?vue&type=script&lang=js&"
export * from "./OrdersKanban.vue?vue&type=script&lang=js&"
import style0 from "./OrdersKanban.vue?vue&type=style&index=0&id=53bd3437&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd3437",
  null
  
)

export default component.exports